export default __webpack_public_path__ + "static/media/gallery-arrow-r.5d3099df.svg";